import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {
  useGlobalContext
} from '../../../../common/components/core/GlobalContext';
import Spinner from '../../../../common/components/ui/Spinner';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import CustomersList from '../CustomersList';
import InputText from '../../../../common/components/ui/InputText';
import {useSelectCustomerPopupContext} from '../../contexts/SelectCustomerPopupContext';
import {RivhitCustomer} from '../../../../common/types';
import search from '../../../../common/assets/icons/search.svg';
import styles from './SelectCustomerWidget.module.scss';

export interface SelectCustomerWidgetProps {
  onCloseClicked: () => void;
}

const SelectCustomerWidget = ({onCloseClicked}: SelectCustomerWidgetProps) => {
  const context = useGlobalContext();
  const {customers, loading} = useSelectCustomerPopupContext();
  const [searchResult, setSearchResult] = useState<RivhitCustomer[]>(customers);

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    if (Boolean(input)) {
      setSearchResult(customers.filter((item) => {
        const regexp = new RegExp(input, 'i');
        return regexp.test(item.customerName)
          || regexp.test(item.idNumber.toString())
          || regexp.test(item.phoneFax.toString())
          || regexp.test(item.address);
      }));
    } else {
      setSearchResult(customers);
    }
  };

  const intl = useIntl();
  const titleText = intl.formatMessage({
    id: 'orderInvoice-modal-search-customers-header',
    defaultMessage: 'Select customer'
  });
  const closeButtonText = intl.formatMessage({
    id: 'button-label-close',
    defaultMessage: 'Close'
  });

  return (
    <div
      dir={context.layoutDirection}
      className={styles.selectCustomerContainer}
    >
      <div className={styles.topBar}>
        <div className={styles.title}>
          {titleText}
        </div>
        <div className={styles.searchCustomers}>
          <img
            src={search}
            alt="search-icon"
            className={styles.searchIcon}
          />
          <InputText
            id={'searchCustomers'}
            variant={'secondary'}
            onChange={handleInputChange}
            customClassnames={{container: styles.searchInput}}
          />
        </div>
      </div>
      <div className={styles.content}>
        {loading
          ? <Spinner/>
          : <CustomersList data={searchResult}/>}
      </div>
      <div className={styles.closeButton}>
        <ButtonAction
          variant={'reject'}
          label={closeButtonText}
          onClick={onCloseClicked}
        />
      </div>
    </div>
  );
};

export default SelectCustomerWidget;
